import { VideoProject } from "@/services/bedrock";

import { getKanbanColumnId, visibleKanbanColumns, KanbanColumnId } from "./kanbanColumns";

export const EDITOR_QUEUE_VIDEO_PROJECT_CHANGED = "video_project.changed";
export const EDITOR_QUEUE_ASSIGNMENTS_CHANGED = "queue_assignments.changed";

export type EditorQueueVideoProjectChanged = {
  type: typeof EDITOR_QUEUE_VIDEO_PROJECT_CHANGED;
  videoProjectId: number;
  fromStatus?: VideoProject.Status | string | null;
  toStatus?: VideoProject.Status | string | null;
  archived?: boolean;
  actorUserId?: number | null;
};

type EditorQueueAssignmentsChanged = {
  type: typeof EDITOR_QUEUE_ASSIGNMENTS_CHANGED;
  coachId: number;
};

export type EditorQueueEvent = EditorQueueVideoProjectChanged | EditorQueueAssignmentsChanged;

export function isEditorQueueEvent(value: unknown): value is EditorQueueEvent {
  if (!value || typeof value !== "object") return false;

  const event = value as { type?: unknown; videoProjectId?: unknown; coachId?: unknown };
  if (event.type === EDITOR_QUEUE_ASSIGNMENTS_CHANGED) {
    return typeof event.coachId === "number";
  }
  if (event.type === EDITOR_QUEUE_VIDEO_PROJECT_CHANGED) {
    return typeof event.videoProjectId === "number";
  }
  return false;
}

export function columnIdsForEditorQueueEvent(
  event: EditorQueueEvent,
  options?: { revealInternalStatuses?: boolean }
): KanbanColumnId[] {
  const revealInternalStatuses = options?.revealInternalStatuses ?? true;
  if (event.type === EDITOR_QUEUE_ASSIGNMENTS_CHANGED) {
    return allKanbanColumnIds(revealInternalStatuses);
  }

  const columnIds = [event.fromStatus, event.toStatus]
    .map(status => {
      if (!status) return undefined;
      const visibleStatus = revealInternalStatuses ? status : VideoProject.clientStatus(status);
      return getKanbanColumnId(visibleStatus as VideoProject.Status);
    })
    .filter((columnId): columnId is KanbanColumnId => columnId != null);

  return columnIds.length > 0 ? [...new Set(columnIds)] : allKanbanColumnIds(revealInternalStatuses);
}

function allKanbanColumnIds(revealInternalStatuses = true): KanbanColumnId[] {
  return visibleKanbanColumns(revealInternalStatuses).map(column => column.id);
}
